import { z } from 'zod';
export const CandidatePairStatsSchema = z.object({
    id: z.string(),
    timestamp: z.number(),
    type: z.literal('candidate-pair'),
    transportId: z.string(),
    localCandidateId: z.string(),
    remoteCandidateId: z.string(),
    state: z.enum(['frozen', 'waiting', 'in-progress', 'failed', 'succeeded']),
    nominated: z.boolean(),
    bytesSent: z.number().optional(),
    bytesReceived: z.number().optional(),
    totalRoundTripTime: z.number().optional(),
    currentRoundTripTime: z.number().optional(),
    availableOutgoingBitrate: z.number().optional(),
    availableIncomingBitrate: z.number().optional(),
    requestsReceived: z.number().optional(),
    requestsSent: z.number().optional(),
    responsesReceived: z.number().optional(),
    responsesSent: z.number().optional()
});
export const CandidateStatsSchema = z.object({
    id: z.string(),
    timestamp: z.number(),
    type: z.enum(['local-candidate', 'remote-candidate']),
    transportId: z.string(),
    isRemote: z.boolean(),
    ip: z.string().optional(),
    port: z.number().optional(),
    protocol: z.enum(['udp', 'tcp']).optional(),
    candidateType: z.enum(['host', 'srflx', 'prflx', 'relay']),
    priority: z.number(),
    url: z.string().optional(),
    relayProtocol: z.enum(['udp', 'tcp', 'tls']).optional(),
    deleted: z.boolean().optional()
});
export const StatsSchema = z.discriminatedUnion('type', [
    CandidatePairStatsSchema,
    CandidateStatsSchema,
    z.object({
        id: z.string(),
        timestamp: z.number(),
        type: z.enum([
            'certificate',
            'codec',
            'data-channel',
            'inbound-rtp',
            'media-source',
            'outbound-rtp',
            'peer-connection',
            'remote-inbound-rtp',
            'remote-outbound-rtp',
            'transport'
        ])
    })
]);
export const StatsReportSchema = z.object({
    forEach: z.function().args(z.function().args(StatsSchema)),
    get: z.function().args(z.string()).returns(StatsSchema)
});
export const isActiveCandidatePair = (statsItem) => Boolean('bytesReceived' in statsItem &&
    statsItem.bytesReceived &&
    statsItem.bytesReceived > 0 &&
    statsItem.state === 'succeeded');
//# sourceMappingURL=model.js.map